import React from "react";
import { ScreenContainerControl } from "doshx_controls_web";
import { AccountMenu } from "../../../components/account-menu/account-menu";
import { ProfileDetailsWidget } from "../profile/details";
import { Breadcrumb } from "../../../components/breadcrumb";
export function AccountPage() {
    return (React.createElement("div", null,
        React.createElement(Breadcrumb, { items: [{ label: "Home" }, { label: "Account" }, { label: "Account Details", active: true }], title: "Account Details" }),
        React.createElement(ScreenContainerControl, { className: "flex flex-col lg:flex-row items-start justify-start gap-8 pt-8 px-8 md:max-w-full" },
            React.createElement("div", { className: "w-full lg:w-1/4 xl:w-1/5" },
                React.createElement(AccountMenu, null)),
            React.createElement("div", { className: "flex flex-col gap-4 w-full lg:w-3/4 xl:w-4/5" },
                React.createElement("div", { className: "text-xl font-semibold" }, "Account Details"),
                React.createElement(ProfileDetailsWidget, null)))));
}
